/**
 * Configuración del paso de pago (Pasarela · 3 — manejo de errores/carga).
 * Spec: docs/specs/checkout-payment-loading-errors-plan.md (DM1, DM2).
 */

/**
 * Timeout (ms) para `createIntent`/`confirm`/`getStatus`. Centralizado en
 * `PaymentService` para que toda pasarela (incl. el `OnvoPaymentProvider` de
 * Pasarela · 5) lo herede. Al expirar, RxJS emite `TimeoutError` por el canal
 * de error y el componente lo mapea a copy de timeout (DM1/DM4).
 */
export const PAYMENT_TIMEOUT_MS = 15_000;

/**
 * Timeout (ms) para `completeCheckout` (flujo de tarjeta diferido): el endpoint verifica el cobro
 * con ONVO y materializa el preorder (cliente + líneas + stock) en una transacción, así que es más
 * pesado que un createIntent/getStatus. Margen mayor para no abortar una materialización en curso.
 */
export const PAYMENT_COMPLETE_TIMEOUT_MS = 30_000;

/**
 * Máximo de intentos terminales del paso (intento inicial + reintentos) antes
 * de empujar al fallback de paylink. Un único cap cubre TANTO el fallo al crear
 * el intent como el de confirmar (DM2/C1): evita bucles de reintento infinito.
 */
export const PAYMENT_MAX_ATTEMPTS = 3;
